import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { tagPicker_template } from "./tagPicker_template";
import { imagePicker_template } from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import { filterDropdown_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template';
import { filterSingleDate_template } from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template'
import { filterArticle_template } from "./filterArticle_template";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import {imagePickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';
import { videoPickerHelper } from "../../../vendor/valnet/valnet_imagePicker/js/modules/videoPickerHelper";
import videoPicker_template from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/videoPicker_template";
import NwsLAB from '../../utils/NewsletterArticlePickerBuilder';

declare var ko: any;

export class newsletterMailEdit_template extends vnTemplate {

    public imagePicker: imagePicker_template;
    public tagPicker: tagPicker_template;
    protected templateSelector: filterDropdown_template;
    protected dateSelector: filterSingleDate_template;
    public articleFilter: filterArticle_template
    protected customRecipientsToolTipButton: infoButton_template;
    public filterProducts: filterAutocomplete_template;
    public filterAffiliates: filterAutocomplete_template;
    public filterProductTypes: filterAutocomplete_template;
    public imagePickerHelper: imagePickerHelper;
    public tagVideoPicker: videoPicker_template;
    public videoPickerHelper: videoPickerHelper;
    protected getTemplateHtml(): string {

        return `
        ${window.location.pathname.indexOf('/newsletter/emails/add')> -1 ?
            `
        <div data-bind="visible:!selectedNewsLetterMode()" class="w-form temp-selector-new is-showing" style="display:inline-block; min-width:70rem">
            <div class="form-header">
                <strong class="form-title">Select Layout</strong>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>

            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group group-3" style="grid-template-columns: none;">
                        <button class="btn-temp-new temp-regular" type="button" data-bind="click:() => onClickSelectNewsLetterMode('regular')">
                            <div class="w-icon"><span class="icon i-newsletter"></span></div>
                            <div class="temp-info"><span>Regular</span><p>Provides standard elements with CSS automatically applied</p></div>
                        </button>
                    </div>
                    <div class="form-group group-4" style="grid-template-columns: none;">
                        <button class="btn-temp-new temp-regular" type="button" data-bind="click:() => onClickSelectNewsLetterMode('custom')">
                            <div class="w-icon"><span class="icon i-star-full"></span></div>
                            <div class="temp-info"><span>Custom</span><p>Allows custom elements and inline CSS</p></div>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div data-bind="visible:selectedNewsLetterMode() == 'custom' && !selectedTemplateId()" class="w-form temp-selector-new is-showing" style="display:inline-block; min-width:70rem">
            <div class="form-header">
                <strong class="form-title">Select Template</strong>
                <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>

            </div>
            <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group group-4 overflow-scroll">
                        <!-- ko foreach: availableNewsLetterTemplates -->
                        <button class="btn-temp-new temp-regular" type="button" data-bind="click:($data) => $parent.onClickSelectTemplate($data)">
                            <div class="w-icon"><span class="icon i-regular-template"></span></div>
                            <div class="temp-info"><span data-bind="text:$data.name"></span></div>
                        </button>
                        <!-- /ko -->
                    </div>
                </div>
            </div>
        </div>` : '' }

            <div class="w-form w-form-large" data-bind="visible: (selectedNewsLetterMode() == 'custom' && selectedTemplateId()) || (selectedNewsLetterMode() == 'regular')">
                <div class="form-header">
                    <h3 class="form-title">Newsletter Builder</h3>
                    <h3 class="form-title" data-bind="text: name"></h3>
                    <button data-bind="event: { click: onClickCancelEdit }" class="close-button icon i-close-2" type="button"></button>

                </div>
                <div class="form-body">

                    <div class="form-group">
                        <label for="subject" class="form-label">Subject</label>
                        <div class="row link">
                            <input id="subject" data-bind="value: subject" type="text" class="input-text">
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="previewText" class="form-label">Preview Text</label>
                        <div class="row link">
                            <input id="previewText" data-bind="value: previewText" type="text" class="input-text">
                        </div>
                    </div>
                    <div class="form-group">
                        <dl class="double-list">
                            <dt><span>Layout</span></dt>
                            <dd><span data-bind="text:selectedNewsLetterMode()"></span></dd>
                        </dl>
                        <dl class="double-list">
                            <dt><span>Template</span></dt>
                            <dd><span data-bind="text: selectedTemplate() && selectedTemplate().name ? selectedTemplate().name : ''"></span></dd>
                         </dl>
                    </div>
                    <div class="form-group ">
                         <label for="contenttext" class="form-label">Content</label>
                         <textarea id="contenttext" data-bind="value: content" ></textarea>
                    </div>

                </div>

                 <div class="form-footer">
                    <button data-bind="event: { click: onClickCancelEdit }" class="btn " type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                    <button data-bind="event: { click: onClickToggleSaveAndSendPopUp.bind($data, true) }, visible: permissions()['newsletter_email_edit'].write" class="btn highlight" type="button">Save & Send</button>
                </div>
            </div>

            ` + this.imagePicker.getHtmlBuild() + `
            ` + this.tagPicker.getHtmlBuild() + `

            <div data-bind="css: { 'is-visible': isArticleInsertPopUpVisible }" class="w-lightbox light-theme lightbox-embed">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Article</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseArticlePopUp }" ></button>
                        </div>
                        <div class="form-body w-article-picker" style="padding:2rem">
                            ${this.articleFilter.getHtmlBuild()}
                            <div class="preview" data-bind="visible: articleInsertPreviewCode">
                                <div class="form-group">
                                    <div class="scrollable" style="max-width:50vw;"  data-bind="html: articleInsertPreviewCode, disable: true" ></div>
                                </div>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCloseArticlePopUp }" class="btn ">Cancel</button>
                            <button type="button" data-bind="disable: articleInsertPreviewCode() == '',  event: { click: onClickInsertIntoEditor }" class="btn highlight">Insert</button>
                        </div>
                    </div>
                </div>
            </div>

            <div data-bind="css: { 'is-visible': isSaveAndSendPopUpVisible }" class="w-lightbox light-theme lightbox-embed">
                <div class="lightbox-content" id="newsletter-confirm-identifier">
                    <div class="w-form lightbox-form" style="width: 50rem">
                        <div class="form-header">
                            <h3 class="form-title">Save and Send</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickToggleSaveAndSendPopUp.bind($data, false) }" ></button>
                        </div>
                        <div class="form-body">

                            <strong class="form-sub-title parent">INFORMATION</strong>
                            <div class="form-group">
                                <div class="form-check-inline" data-bind="visible: selectedNewsLetterMode() == 'regular'">
                                    <label for="date" class="form-label">Template</label>
                                    ${this.templateSelector.getHtmlBuild()}
                                </div>
                                <div class="form-check-inline">
                                    <label for="date" class="form-label">Date Scheduled</label>
                                    ${this.dateSelector.getHtmlBuild()}
                                </div>
                            </div>
                            <strong class="form-sub-title parent">Recipients</strong>

                            <strong class="form-sub-title content">Mailing Lists</strong>
                            <div class="form-group mailinglist">
                                <div data-bind="foreach: recipients">
                                    <input type="checkbox" data-bind="attr: {id: 'recipient' + id}, value: id, checked: $parent.selectedRecipients">
                                    <label class="form-label icon i-check"  data-bind="text: name, attr: {for: 'recipient' + id}"></label>
                                </div>
                            </div>

                            <strong class="form-sub-title content">SPECIFIC EMAIL ADDRESSES</strong>
                            <div class="form-group custom-mailing-list" data-bind="class: emailErrors().length > 0 ? 'is-error' : ''">>
                                <label for="customRecipients" class="form-label">Custom
                                    <div class="w-tooltips-adv pos-far-right short" style="display: inline-block;transform: translateY(4px);">
                                    ` + this.customRecipientsToolTipButton.getHtmlBuild() + `
                                    </div>
                                </label>

                                <textarea id="customRecipients" data-bind="value: recipientEmails, valueUpdate: 'afterkeydown'" type="text" class="input-text"></textarea>

                                <ul data-bind="visible: emailErrors().length > 0, foreach: emailErrors" class="errors">
                                    <li data-bind="text: $data"></li>
                                </ul>
                            </div>

                            <div class="form-group">
                                <div class="form-check-inline">
                                    <input id="myself" data-bind="checked: sendToSelf, value: 'self'" type="checkbox">
                                    <label for="myself" class="form-label icon i-check">Send to Email Address of Logged In User</label>
                                </div>
                            </div>

                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickToggleSaveAndSendPopUp.bind($data, false) }" class="btn ">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSend }" class="btn highlight">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>
            ${ this.tagVideoPicker.getHtmlBuild() }
            `;
    }

    protected getTemplateName(): string {
        return "newsletterEmail-template";
    }

    protected getMainElementClasses(): string[] {

        return ["newsletter-builder"];
    }

    public showTagPicker(mode, target) {

        this.tagPicker.setMode(mode);
        this.tagPicker.setTarget(target);
        this.setTagPickerTarget(target);
        //this.caller.getTagData();
        this.tagPicker.show();
    }

    public setTagPickerTarget(tagPickerTarget) {
        this.getTemplateViewModel().tagPickerTarget(tagPickerTarget);
    }

    protected initPartial() {

        this.templateSelector = new filterDropdown_template('templateSelector', this.getTemplateViewModel(), this.caller);
        this.templateSelector.setLabel('Template');
        this.dateSelector = new filterSingleDate_template('dateSelector', this.getTemplateViewModel(), this.caller);
        this.dateSelector.setDate(this.getFormattedEasternTimeZoneDateTime());
        this.dateSelector.setMinutesInterval(1);

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePicker.setNumberOfRecentImages(50);

        this.tagPicker = new tagPicker_template("tagPicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker.setParent(this);
        this.tagPicker.tagView.set_enableTagVideo(false);

        this.articleFilter = new filterArticle_template("filterArticle", this.getTemplateViewModel(), this.caller);
        this.articleFilter.setShowDetails(true);
        this.articleFilter.setIsLoadingAnimationEnable(true);

        this.customRecipientsToolTipButton = new infoButton_template('customRecipientsToolTipButton', this.getTemplateViewModel(), this.caller)
        this.customRecipientsToolTipButton.setTitle('Help: Custom');

        let customRecipientstoolTipText = '' +
            '<div style="display: flex;align-items: flex-start">' +
            '<p>Input comma-separated email addresses to receive a copy of the email. Spaces will be stripped.</p>' +
            '</div>'
            ;

        this.customRecipientsToolTipButton.setContent(customRecipientstoolTipText);

        this.filterProducts = new filterAutocomplete_template("filterAutocompleteProduct_template", this.getTemplateViewModel(), this.caller);
        // this.filterProducts.setFilterIconCSSClass( 'i-article-a' );
        this.filterProducts.setClearInputConfirmMessage("Are you sure you want to change the product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewClearConfirmMessage("Are you sure you want to add a new product name? Newly entered product specifications and selected fields will be lost");
        this.filterProducts.setAddNewOptionEnabled(true);
        this.filterProducts.setHasDisplayNameComplement(true);
        this.filterProducts.setNumberOfChars(1);
        this.filterProducts.setPlaceholderAndLabel("Product");
        this.filterProducts.setOptionType("Product name");

        this.filterAffiliates = new filterAutocomplete_template("filterAutocompleteAffiliate_template", this.getTemplateViewModel(), this.caller);
        // this.filterProducts.setFilterIconCSSClass( 'i-article-a' );
        this.filterAffiliates.setAddNewOptionEnabled(true);
        this.filterAffiliates.setNumberOfChars(1);
        this.filterAffiliates.setPlaceholderAndLabel("Affiliate Partner");
        this.filterAffiliates.setOptionType("Affiliate Partner");

        this.filterProductTypes = new filterAutocomplete_template("filterAutocompleteProductType_template", this.getTemplateViewModel(), this.caller);
        // this.filterProductTypes.setFilterIconCSSClass( 'i-article-a' );
        this.filterProductTypes.setClearInputConfirmMessage("Are you sure you want to change the product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setAddNewClearConfirmMessage("Are you sure you want to add a new product type? Newly entered product specifications and selected fields will be lost");
        this.filterProductTypes.setPlaceholderAndLabel('Product Type');
        this.filterProductTypes.setOptionType("Product Type");
        this.filterProductTypes.setNumberOfChars(1);
        this.filterProductTypes.setAddNewOptionEnabled(true);

        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );

        this.tagVideoPicker = new videoPicker_template("tagVideoPicker", this.getTemplateViewModel(), this.caller);
        this.videoPickerHelper = new videoPickerHelper(
            this.tagVideoPicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );
    }

    public buildDatePickerCalendar() {

        this.dateSelector.buildCalendar(this.createEasternTimeZoneDateTime());
    }

    protected buildViewModel(): any {
        let self = this
        return {
            id: ko.observable(""),
            subject: ko.observable(""),
            previewText: ko.observable(""),
            content: ko.observable(""),
            sendToSelf: ko.observable(false),
            recipientEmails: ko.observable(""),
            recipients: ko.observableArray([]),
            selectedRecipients: ko.observableArray([]),
            imagePickerTarget: ko.observable(null),
            isArticleInsertPopUpVisible: ko.observable(false),
            articleInsertPreviewCode: ko.observable(''),
            isSaveAndSendPopUpVisible: ko.observable(false),
            tagPickerTarget: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions(['newsletter_email_view', 'newsletter_email_edit'])),
            emailErrors: ko.observableArray([]),
            selectedNewsLetterMode : ko.observable(null),
            availableNewsLetterTemplates : ko.observableArray([]),
            selectedTemplate : ko.observable(null),
            selectedTemplateId : ko.observable(null),
            finalPreviewElementId: ko.observableArray(null),
            onClickCancelEdit (data, event) {
                self.cancelEdit();
            },
            onClickSave (data, event) {
                self.onClickSave();
            },
            onClickSaveAndStay (data, event) {
                self.onClickSaveAndStay();
            },
            onClickSend (data, event) {
                self.onClickSend();
            },
            onFocusOutStaticPageName: (data, event) => {
                // self.onFocusOutStaticPageName(event);
            },
            onClickCloseArticlePopUp (data, event) {
                self.onClickCloseArticlePopUp();
            },
            onClickToggleSaveAndSendPopUp (value, data, event) {
                self.toggleSaveAndSendPopUp(value);
            },
            onClickInsertIntoEditor (data, event) {
                self.onClickInsertIntoEditor();
            },
            onClickSelectNewsLetterMode(newsLetterMode) {
                self.onClickSelectNewsLetterMode(newsLetterMode);
            },
            onClickSelectTemplate(template) {
                self.onClickSelectTemplate(template);
            }
        };
    }

    getViewModelForRequest(): any {

        return {
            idMail: this.getTemplateViewModel().id(),
            content: this.getTemplateViewModel().content(),
            idTemplate: this.templateSelector.getTemplateViewModel().selectedOption,
            selectedRecipients: this.getTemplateViewModel().selectedRecipients(),
            recipientEmails: this.getTemplateViewModel().recipientEmails(),
            sendToSelf: this.getTemplateViewModel().sendToSelf(),
            subject: this.getTemplateViewModel().subject(),
            previewText: this.getTemplateViewModel().previewText(),
            dateScheduled: this.dateSelector.getTemplateViewModel().singleDatePicker(),
            mode : this.getTemplateViewModel().selectedNewsLetterMode(),
            selectedTemplate : this.getTemplateViewModel().selectedTemplate(),
            selectedTemplateId : this.getTemplateViewModel().selectedTemplateId(),
        };
    }

    public showImagePicker(mode, target, keyword = null) {

        this.imagePicker.setMode(mode);
        this.setImagePickerTarget(target);
        this.imagePicker.setTarget(target);
        this.caller.getImageData(keyword);
        if (mode === "multi-select") {
            this.caller.getImagesInContent(target);
        }
        this.imagePicker.show();
    }

    public setTemplates(templates) {

        this.templateSelector.setOptions(templates);
    }

    public setRecipients(recipients) {

        this.getTemplateViewModel().recipients(recipients);
    }

    public setContent(content) {

        this.getTemplateViewModel().content(content);
    }

    public setDateScheduled(dateScheduled) {

        this.getTemplateViewModel().dateScheduled(dateScheduled);
    }

    public setIdTemplate(idTemplate) {

        this.getTemplateViewModel().idTemplate(idTemplate);
    }

    public setId(id) {

        this.getTemplateViewModel().id(id);
    }

    public getImagePickerTarget() {
        return this.getTemplateViewModel().imagePickerTarget();
    }

    public setImagePickerTarget(imagePickerTarget) {
        this.getTemplateViewModel().imagePickerTarget(imagePickerTarget);
    }

    public setVideoPickerTagFilter(tags) {
        this.videoPickerHelper.setTagsSuggestions(tags);
    }

    public onClickSave() {

        this.caller.save('save');
    }

    public onClickSaveAndStay() {

        this.caller.save('stay');
    }

    public isSectionForTagPicker(sectionName: string): boolean {

        let tpSections = ['featuredTag'];

        let fs = tpSections.filter((s) => s == sectionName);

        return (fs.length > 0);
    }

    public editTagElement(tagElement, editor) {

        this.showTagPicker("in-content", editor);
        this.tagPicker.editTagElement(tagElement);
    }

    public editTagGroup(groupElement, editor) {

        this.showTagPicker("in-content", editor);
        this.tagPicker.setTagGroupElement(groupElement);
    }

    public initTagPickerCkEditors(): void {

        this.tagPicker.initializeCkEditors();
    }

    public getPermissions() {

        return this.getTemplateViewModel().permissions();
    }

    public setSubject(subject) {

        this.getTemplateViewModel().subject(subject)
    }

    public setPreviewText(previewText) {

        this.getTemplateViewModel().previewText(previewText)
    }

    public toggleArticleInsertPopUp(bool) {

        this.getTemplateViewModel().isArticleInsertPopUpVisible(bool)
    }

    public setArticleInsertPreviewCode(html) {

        this.getTemplateViewModel().articleInsertPreviewCode(html)
    }

    public toggleSaveAndSendPopUp(bool) {

        this.getTemplateViewModel().emailErrors([]);
        this.getTemplateViewModel().isSaveAndSendPopUpVisible(bool);
        this.dateSelector.setDate(this.getFormattedEasternTimeZoneDateTime());
    }

    public onClickCloseArticlePopUp() {

        this.toggleArticleInsertPopUp(false);
        this.resetArticleInsertPopUp();
    }

    public onClickInsertIntoEditor() {

        let html = this.getTemplateViewModel().articleInsertPreviewCode();
        const finalHtml = document.getElementById(this.getFinalPreviewElementId());
        if (finalHtml) {
            html = finalHtml.innerHTML;
            this.setFinalPreviewElementId(null);
            this.caller.insertIntoEditor(NwsLAB.refineHtml(html));
            this.resetArticleInsertPopUp();
            this.toggleArticleInsertPopUp(false);
            return;
        }
        this.caller.insertIntoEditor(html);
        this.resetArticleInsertPopUp();
        this.toggleArticleInsertPopUp(false);
    }

    public refineHtml(html: string): string {
        const container = document.createElement('div');
        container.innerHTML = html;
        container
            .querySelectorAll('[data-display="false"]')
            .forEach((element) => element.remove());
        container
            .querySelectorAll('[data-bind], [data-display]')
            .forEach((element) => {
                element.removeAttribute('data-bind');
                element.removeAttribute('data-display');
            });
        return container.innerHTML.trim();
    }


    public resetArticleInsertPopUp() {

        this.articleFilter.getTemplateViewModel().idArticle(null);
        this.articleFilter.getTemplateViewModel().article("");
        this.articleFilter.getTemplateViewModel().articleObj("");
        this.getTemplateViewModel().articleInsertPreviewCode("");
    }

    public onClickSend() {

        let recipientEmails = this.getTemplateViewModel().recipientEmails().replace(/^\s+|\s+$/g, '');

        if (recipientEmails.length > 0) {
            let isValid = true;
            let emailErrors: Array<string> = [];
            let numberOfLineBreaks = (recipientEmails.match(/\n/g) || []).length;
            if (numberOfLineBreaks > 0) {
                isValid = false;
                emailErrors.push('Line breaks are not allowed.');
            }

            let numberOfHtml = (recipientEmails.match(/<\/?[\w\s="/.':;#-\/\?]+>/gi) || []).length;
            if (numberOfHtml > 0) {

                isValid = false;
                emailErrors.push('Html tags are not allowed.');
            }

            if (isValid) {

                let emails = recipientEmails.split(',').map((e) => e.trim());

                const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
                for (let email of emails) {

                    if (!emailRegex.test(email)) {
                        isValid = false;
                        emailErrors.push(email + ' is invalid');
                    }
                }
            }

            if (!isValid) {

                this.getTemplateViewModel().emailErrors(emailErrors);

                return;
            }

            this.getTemplateViewModel().emailErrors([]);
        }

        this.caller.sendNewsletter();
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions)
        this.imagePicker.setPermissions(permissions);
        this.tagPicker.setPermissions(permissions);
        this.videoPickerHelper.setPermissions(permissions);
    }

    public cancelEdit() {

        this.caller.redirectToMailList()
    }

    public closeImage(target) {
        let element = document.getElementById(target);
        element!.classList.remove("is-viewing");
    }

    public removeImage(target) {

        if (target == 'video_thumbnail'){
            this.videoPickerHelper.clearThumbnailImage()
        }
    }

    public addTagPickerValidationClass() {

        document.body.classList.add('_tagpicker')
    }

    public removeTagPickerValidationClass() {

        document.body.classList.remove('_tagpicker')
    }

    public onChangeSelectTag() {

        let productsViewModel = this.filterProducts.getTemplateViewModel();
        let typesViewModel = this.filterProductTypes.getTemplateViewModel();
        let productTag = !productsViewModel.addNewSelected() ? productsViewModel.optionObj() : null;
        let tagType = !typesViewModel.addNewSelected() ? typesViewModel.optionObj() : null;
        let specValues = productTag && productTag.specifications_extra ? JSON.parse(JSON.stringify(productTag.specifications_extra)) : [];

        let tagExtra = productTag && productTag.details ? JSON.parse(JSON.stringify(productTag.details)) : [];

        let seoDescription = tagExtra.shortDescription ? tagExtra.shortDescription : null;
        let productText = tagExtra.description ? tagExtra.description : null;
        let affiliateLinks = tagExtra.affiliateLinks ? tagExtra.affiliateLinks : [];
        let image = tagExtra.image ? tagExtra.image : null;

        this.getTemplateViewModel().reviewItemSeoDescription(seoDescription);
        this.getTemplateViewModel().reviewItemAffiliateLinks(affiliateLinks);

        this.caller.setReviewText(productText);

        if (image) {

            this.addProductImage(image);
        }

        /*
            Here, the plan is, if you have a type and a product, get specifications extra from tag type field values extra
            otherwise if you only have a type, query for the fields only with

         */

        let specs = [], spec;

        if (tagType && typeof tagType.fields != "undefined" && tagType.fields.length > 0) {

            tagType.fields.forEach(field => {

                spec = { fieldId: field.id, label: field.label, data: null, dataType: field.dataType };

                for (let i = 0; i < specValues.length; i++) {

                    if (specValues[i].idField == field.id) {

                        spec['data'] = specValues[i].value;
                        specValues.splice(i, 1);
                        break;
                    }
                }
                specs.push(spec);
            })
        }
        if (productTag && productTag.details && productTag.details.image) {

            this.getTemplateViewModel().tagImage(productTag.details.image);
        }

        this.getTemplateViewModel().reviewItemTagSpecifications(specs)
    }

    public setProductImages(images) {

        for (let i = 0; i < images.length; i++) {
            this.addProductImage(images[i]);
        }
    }

    public addProductImage(image) {

        let imageSelected = this.getTemplateViewModel().reviewItemImages().find(x => x.id == image.id);
        if (!imageSelected) {
            let images = this.getTemplateViewModel().reviewItemImages();
            images.push(image);
            this.getTemplateViewModel().reviewItemImages([]);
            this.getTemplateViewModel().reviewItemImages(images);
        }
        this.onLoadTemplate('#img_list_product_review .img-article-item', this.reorderReviewItemImages.bind(this));

    }

    private onLoadTemplate(dragItemSelector, sortFunction) {

        var parent = this;
        var dragSrcEl = null;

        function handleDragStart(e) {
            // Target (this) element is the source node.
            dragSrcEl = this;

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }
        function handleDragOver(e) {
            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll(dragItemSelector);
            let index = 0;
            let found = false;
            for (let item of dragItems) {
                if (dragSrcEl == item) {

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if (this == item) {

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if (!found) {
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {
            // this / e.target is the current hover target.
            //this.classList.add('over');

            //this.classList.add('before');
        }

        function handleDragLeave(e) {
            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {
            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {
                var dropHTML = e.dataTransfer.getData('text/html');

                if (dropHTML.includes("<li")) {
                    for (let child of this.parentNode.childNodes) {

                        if (child == dragSrcEl) {
                            this.parentNode.removeChild(dragSrcEl);
                        }
                    }

                    if (this.classList.contains("before")) {
                        this.insertAdjacentHTML('beforebegin', dropHTML);
                        var dropElem = this.previousElementSibling;
                    } else {
                        this.insertAdjacentHTML('afterend', dropHTML);
                        var dropElem = this.nextElementSibling;
                    }

                    addDnDHandlers(dropElem);
                    //this.reorderImages();
                }
            }
            sortFunction(parent);
            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {
            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {
                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {
            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);

        }

        //var dragItems = document.querySelectorAll('[draggable=true]');
        var cols = document.querySelectorAll(dragItemSelector);
        [].forEach.call(cols, addDnDHandlers);
    }

    protected reorderReviewItemImages(huit_neuf_this) {
        let images = huit_neuf_this.getTemplateViewModel().reviewItemImages();
        let selector = '#img_list_product_review .img-article-item';
        let liElements = document.querySelectorAll(selector);

        //reorder the images based on HTML order
        let newImages = []
        for (let element of liElements) {

            let idElement = element.id;
            let image = images.find(i => i.id === Number(element.id));
            if (image) {
                newImages.push(image);
            }
        }
        huit_neuf_this.getTemplateViewModel().reviewItemImages([]);
        huit_neuf_this.getTemplateViewModel().reviewItemImages(newImages);
        huit_neuf_this.onLoadTemplate(selector, huit_neuf_this.reorderReviewItemImages.bind(huit_neuf_this));
    }

    private getFormattedEasternTimeZoneDateTime(): any {

        let date = this.createEasternTimeZoneDateTime();

        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hour = date.getHours();
        let minutes = date.getMinutes();

        return year + '/' + this.padInteger(month, 2) + '/' + this.padInteger(day, 2) + ' ' + this.padInteger(hour, 2) + ':' + this.padInteger(minutes, 2);
    }

    private createEasternTimeZoneDateTime(date?: Date): Date {

        if (!date) {
            date = new Date();
        }

        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        //checks if DST is currently being observed, adjusts offset accordingly
        let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
        date.setMinutes(date.getMinutes() + easternTimeOffset);

        return date;
    }

    private padInteger(number: number, size: number) {
        let s = number + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    public isDstObserved(date?: Date) {
        let jan = new Date(date.getFullYear(), 0, 1);
        let jul = new Date(date.getFullYear(), 6, 1);
        let stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

        return date.getTimezoneOffset() < stdTimezoneOffset;
    }

    public removeValidationClass() {

        document.body.classList.remove('_form-sub')
    }

    public handleTagInArticle(target: string): void {
        switch (target) {
            case 'tag_picker_edit_cancel':

                this.caller.clearValidationErrors();
                this.removeTagPickerValidationClass();
                this.tagPicker.tagEdit.hide();
                break;
            case 'tag_picker_edit':

                this.tagPicker.tagEdit.setTag(this.caller.getTagToEdit());
                this.tagPicker.tagEdit.show();
                break;
        }
    }

    public getNewsletterConfirmElement() {
        return document.getElementById('newsletter-confirm-identifier');
    }

    public setIsImageOptimized(val) {
        // TODO implement method when you delete an image through imagePickerHelper
    }

    public setFinalPreviewElementId(selector: string|null) {
        this.getTemplateViewModel().finalPreviewElementId(selector);
    }

    public getFinalPreviewElementId() {
        return this.getTemplateViewModel().finalPreviewElementId();
    }

    onClickSelectNewsLetterMode(newsLetterMode): any {
        this.setNewsletterMode(newsLetterMode);

        if (newsLetterMode === NwsLAB.CUSTOM_MODE) {
            this.caller.initializeCkEditors(newsLetterMode)
        }
    }

    onClickSelectTemplate(template) : any {
        this.setSelectedTemplate(template || null);
        this.setSelectedTemplateId(template.id || null);

        const newsLetterMode = this.getNewsletterMode();

        if (newsLetterMode === NwsLAB.CUSTOM_MODE) {
            this.caller.initializeCkEditors(newsLetterMode)
        }
    }

    setNewsletterMode(mode) {
        this.getTemplateViewModel().selectedNewsLetterMode(mode);
    }
    getNewsletterMode() {
        return this.getTemplateViewModel().selectedNewsLetterMode();
    }

    setSelectedTemplate(template) {
        this.getTemplateViewModel().selectedTemplate(template);
    }

    getSelectedTemplate() {
        return this.getTemplateViewModel().selectedTemplate();
    }

    setSelectedTemplateId(id) {
        this.getTemplateViewModel().selectedTemplateId(id);
    }

    getSelectedTemplateId() {
        return this.getTemplateViewModel().selectedTemplateId();
    }

    setAvailableNewsLetterTemplates(templates) {
        this.getTemplateViewModel().availableNewsLetterTemplates(templates);
    }

    public getAvailableNewsLetterTemplates() {
        return this.getTemplateViewModel().availableNewsLetterTemplates();
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterMailEdit_template.ts